import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    locale: "ja",
    auth: false,
    provider: null
  },
  mutations: {
    setLocale: (state, payload) => {
      state.locale = payload
    },
    setAuth: (state, payload) => {
      state.auth = payload
    },
    setGroup: (state, payload) => {
      state.group = payload
    },
    setProvider: (state, payload) => {
      state.provider = payload
    }
  },
  getters: {
    getLocale: (state) => {
      return state.locale
    },
    getAuth: (state) => {
      return state.auth
    },
    getGroup: (state) => {
      return state.group
    },
    getProvider: (state) => {
      return state.Provider
    }
  },
  actions: {},
  plugins: [createPersistedState({storage: window.localStorage})]
});
